import React from "react";
import axios from "../../../containers/api";
import {
  Button,
  Card,
  CardBody,
  Row,
  Label,
  Input,
  FormGroup,
  Badge,
  Alert,
} from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { showCatchError, toEnglishNumbers } from "../../../helpers/Utils";
import { GetDistinctLoaderTypes } from "../../../helpers/Utils";
class AddDriver extends React.Component {
  state = {
    errors: [],
    Data: [],
    NationalId: "",
    Name: "",
    Family: "",
    CardNumber: "",
    FreighterCardNumber: "",
    Mobile: "",
    LoaderType: null,
    loaderTypes: [],
    loaderTypeCodes: [],
    PlaqueNumber: "",
    PlaqueSerialNumber: 0,
    selectedLoaderTypes: [],
  };

  componentDidMount() {
    try {
      this.GetDistinctLoaderTypes().then((r) => console.log(r));
    } catch (err) {
      console.log(err);
    }
  }
  async GetDistinctLoaderTypes() {
    try {
      await GetDistinctLoaderTypes().then((res) => {
        this.setState({ loaderTypeCodes: res.data });
      });
    } catch (err) {
      this.props.showAlert(showCatchError(err), "error");
    }
  }

  getLoaderTypesByCode = (Code) => {
    console.log("code" + Code);
    axios
      .get("/api/v1/loader-types/GetLoaderTypeByCode?Code=" + Code)
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ loaderTypes: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
        this.props.showAlert(showCatchError(error), "error");
      });
  };

  selectHandleChange = (event, value, name) => {
    if (name === "selectedLoaderTypeCode") {
      if (value !== undefined && value !== null) {
        this.setState({ selectedLoaderTypes: [] }, () =>
          this.getLoaderTypesByCode(value.typeCode),
        );
      } else {
        this.setState({
          selectedLoaderTypes: [],
        });
      }
    }
    this.setState({ [name]: value });
  };

  reset = () => {
    this.props.closeSweetAlert();
    this.setState({
      Data: [],
      NationalId: "",
      FreighterCardNumber: "",
      Mobile: "",
    });
  };

  validateInputData = () => {
    this.props.closeSweetAlert();
    let error = [];
    if (
      this.state.NationalId === null ||
      this.state.NationalId === undefined ||
      this.state.NationalId.trim() === ""
    ) {
      error.push("وارد كردن شماره ملی الزامی میباشد.");
    }
    if (
      this.state.FreighterCardNumber === null ||
      this.state.FreighterCardNumber === undefined ||
      this.state.FreighterCardNumber.trim() === ""
    ) {
      error.push("وارد كردن هوشمند ناوگان الزامی میباشد.");
    }
    if (
      this.state.Mobile === null ||
      this.state.Mobile === undefined ||
      this.state.Mobile.trim() === ""
    ) {
      error.push("وارد كردن تلفن همراه الزامی میباشد.");
    }

    this.setState({ errors: error });
    if (error.length === 0) {
      this.AddDriver();
    } else {
      this.props.showAlert(
        "لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!",
        "error",
      );
    }
  };

  AddDriver = () => {
    let model = {
      Name: this.state.Name,
      Family: this.state.Family,
      CardNumber: this.state.CardNumber,
      PlaqueNumber: this.state.PlaqueNumber,
      PlaqueSerialNumber: toEnglishNumbers(this.state.PlaqueSerialNumber),
      LoaderTypeId: this.state.LoaderType.id,
      NationalId: toEnglishNumbers(this.state.NationalId),
      CarSmartCard: toEnglishNumbers(this.state.FreighterCardNumber),
      Mobile: toEnglishNumbers(this.state.Mobile),
      Imei: null,
    };

    this.props.showSpinner();
    axios
      .post("/api/v1/drivers", model)
      .then((res) => {
        this.props.hideSpinner();
        if (res.data !== null) {
          if (res.data.statusCode === 200) {
            this.setState(
              {
                Data: res.data.data,
              },
              () => console.log(this.state.Data.data),
            );
            this.props.showAlert(res.data.message, "success");
            //console.log(res.data.data);
          } else {
            this.props.showAlert(res.data.errors[0], "error");
          }
        }
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  render() {
    return (
      <>
        <Row>
          <Colxx xxs="12">
            <h3>افزودن راننده جديد</h3>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Row className="mb-3">
          <Colxx xxs="12">
            <Card>
              <CardBody className="d-flex flex-column align-items-center">
                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-100">
                  <FormGroup className="w-md-25 w-100 mx-1">
                    <Label>نام راننده</Label>
                    <Input
                      value={this.state.Name}
                      onChange={(e) => this.setState({ Name: e.target.value })}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-25 w-100 mx-1">
                    <Label>نام خانوادگی راننده</Label>
                    <Input
                      value={this.state.Family}
                      onChange={(e) =>
                        this.setState({ Family: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 mx-1">
                    <Label>تلفن همراه</Label>
                    <Input
                      value={this.state.Mobile}
                      maxLength={11}
                      onChange={(e) =>
                        this.setState({
                          Mobile: e.target.value.replace(/[^0-9۰-۹]/g, ""),
                        })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-25 w-100 mx-1">
                    <Label>شماره ملی راننده</Label>
                    <Input
                      value={this.state.NationalId}
                      maxLength={10}
                      onChange={(e) =>
                        this.setState({ NationalId: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 mx-1">
                    <Label>هوشمند ناوگان</Label>
                    <Input
                      value={this.state.FreighterCardNumber}
                      maxLength={7}
                      onChange={(e) =>
                        this.setState({ FreighterCardNumber: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 mx-1">
                    <Label>شماره پلاک</Label>
                    <Input
                      value={this.state.PlaqueNumber}
                      onChange={(e) =>
                        this.setState({ PlaqueNumber: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 mx-1">
                    <Label>سریال پلاک</Label>
                    <Input
                      value={this.state.PlaqueSerialNumber}
                      onChange={(e) =>
                        this.setState({ PlaqueSerialNumber: e.target.value })
                      }
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* ناوگان :</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="selectedLoaderTypeCode"
                      options={this.state.loaderTypeCodes}
                      getOptionLabel={(option) => option.loaderTypeName}
                      value={this.state.selectedLoaderTypeCode}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "selectedLoaderTypeCode")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                  <FormGroup className="w-md-20 w-100 px-1">
                    <Label>* بارگیر :</Label>
                    <Autocomplete
                      clearText={"حذف"}
                      closeText={"بستن"}
                      noOptionsText={"در حال دریافت اطلاعات.."}
                      openText={"باز کردن"}
                      className="react-select__control"
                      id="LoaderType"
                      options={this.state.loaderTypes}
                      getOptionLabel={(option) =>
                        option.loaderTypeName + " " + option.loaderTypeDesc
                      }
                      value={this.state.LoaderType}
                      onChange={(e, v) =>
                        this.selectHandleChange(e, v, "LoaderType")
                      }
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" />
                      )}
                    />
                  </FormGroup>
                </div>

                {this.state.errors.length === 0 ? null : (
                  <div>
                    {this.state.errors.map((error, i) => {
                      return (
                        <Alert color="danger" key={i}>
                          {error}
                        </Alert>
                      );
                    })}
                  </div>
                )}

                <div className="mt-4">
                  <Button
                    className="mx-3 my-md-0 my-1"
                    color="primary"
                    onClick={() =>
                      this.props.showSweetAlert(
                        "آیا از ثبت این راننده مطمئن هستید؟",
                        "",
                        "warning",
                        this.validateInputData,
                      )
                    }
                  >
                    افزودن‌
                  </Button>
                  <Button
                    outline
                    color="secondary"
                    className="mx-3 my-md-0 my-1"
                    onClick={() =>
                      this.props.showSweetAlert(
                        "",
                        "آیا می‌خواهید تمام اطلاعات واردشده را پاک کنید؟",
                        "danger",
                        this.reset,
                      )
                    }
                  >
                    پاک کردن
                  </Button>
                </div>

                {this.state.Data && this.state.Data.data && (
                  <div className="d-flex flex-md-row flex-column w-100 justify-content-center">
                    <Row className="mb-3">
                      <Colxx xxs="12">
                        <CardBody className="d-flex flex-column align-items-center">
                          <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <h3>ثبت نام راننده با موفقيت انجام شد</h3>
                          </div>
                          <Separator className="my-5" />

                          <div className="d-flex flex-md-row flex-column flex-wrap justify-content-around align-items-center w-100">
                            <FormGroup className="w-md-50 w-100 px-1">
                              <Label>نام</Label>
                              <Input
                                value={this.state.Data.data.name}
                                disabled={true}
                              />
                            </FormGroup>
                            <FormGroup className="w-md-50 w-100 px-1">
                              <Label>نام و نام خانوادگي</Label>
                              <Input
                                value={this.state.Data.data.family}
                                disabled={true}
                              />
                            </FormGroup>
                          </div>
                        </CardBody>
                      </Colxx>
                    </Row>
                  </div>
                )}
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </>
    );
  }
}

export default AddDriver;
